import { HeroSection, HowItWorks } from '../components/home-new';
import { KycReminderBanner } from '../components/home-new/KycReminderBanner';

const HomePageNew = () => {
  return (
    <>
      <KycReminderBanner />
      <HeroSection />
      <HowItWorks />
    </>
  );
};

export default HomePageNew;
